"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.UninstallArguments = exports.UninstallOptions = void 0;
exports.UninstallOptions = [
    {
        name: "mode",
        type: "string",
        description: "Choose a way to clean up resources",
        required: true,
        default: "manifest-id",
        choices: ["manifest-id", "env", "title-id"],
    },
    {
        name: "manifest-id",
        type: "string",
        description: "Manifest ID",
    },
    {
        name: "env",
        type: "string",
        description: "Environment",
    },
    {
        name: "projectPath",
        type: "string",
        description: "Project Path for uninstall",
        default: "./",
    },
    {
        name: "options",
        type: "array",
        description: "Choose resources to uninstall",
        choices: ["m365-app", "app-registration", "bot-framework-registration"],
    },
    {
        name: "title-id",
        type: "string",
        description: "Title ID",
    },
];
exports.UninstallArguments = [];
//# sourceMappingURL=UninstallOptions.js.map